import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqData = [
  {
    q: "Hva er Chamonix?",
    a: "LYKKE CHAMONIX er en romslig wellness-badstue med integrert forhall og separat dusjsone, designet for 6–8 personer. Den kombinerer en fullstendig badstuopplevelse med praktisk forhall og dusjmuligheter."
  },
  {
    q: "Hva er inkludert i standardprisen?",
    a: "HUUM Hive Mini 9 kW ovn, Aspetre STS4 panel, LED-belysning, varmebehandlet tregulv, hertet glass dør, multi-nivå hengende benker, forhall, og LYKKE löyly pakke."
  },
  {
    q: "Kan jeg tilpasse farger og materialer?",
    a: "Ja, CHAMONIX kan tilpasses med alternative paneler, utvendig kledning, glassbehandlinger, ovner, og belysning. Se tilleggsalternativer i konfiguratoren."
  },
  {
    q: "Hva er leveringstiden?",
    a: "Standard leveringstid er 6–8 uker fra ordrebekreftelse."
  },
  {
    q: "Hvor mange personer passer i CHAMONIX?",
    a: "CHAMONIX er designet for 6–8 personer. Romslig innvendig volum med komfortable benker på flere nivåer."
  },
  {
    q: "Kan CHAMONIX brukes hele året?",
    a: "Ja, CHAMONIX er designet for helårsbruk. Du kan oppgradere til varmeledende gulv for optimal komfort på vinterdag."
  }
];

export default function ChamonixFaqAccordion() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <div className="space-y-3">
      {faqData.map((item, i) => (
        <button
          key={i}
          onClick={() => setOpenIdx(openIdx === i ? null : i)}
          className="w-full text-left border border-foreground/10 p-5 hover:bg-foreground/2 transition-colors rounded-sm"
        >
          <div className="flex items-center justify-between">
            <h3 className="font-body text-2xl font-medium text-foreground">{item.q}</h3>
            <motion.div animate={{ rotate: openIdx === i ? 180 : 0 }} transition={{ duration: 0.2 }}>
              <ChevronDown size={18} className="text-foreground/40" />
            </motion.div>
          </div>
          <AnimatePresence>
            {openIdx === i && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
                className="overflow-hidden"
              >
                <p className="text-foreground/60 text-lg leading-relaxed mt-4 font-body">{item.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </button>
      ))}
    </div>
  );
}